import { render, staticRenderFns } from "./commonButton.vue?vue&type=template&id=0ede8989&scoped=true"
import script from "./commonButton.vue?vue&type=script&lang=js"
export * from "./commonButton.vue?vue&type=script&lang=js"
import style0 from "./commonButton.vue?vue&type=style&index=0&id=0ede8989&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ede8989",
  null
  
)

export default component.exports